import { render, staticRenderFns } from "./payAddAccount.vue?vue&type=template&id=3fb33f06&scoped=true&"
import script from "./payAddAccount.vue?vue&type=script&lang=js&"
export * from "./payAddAccount.vue?vue&type=script&lang=js&"
import style0 from "./payAddAccount.vue?vue&type=style&index=0&id=3fb33f06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb33f06",
  null
  
)

export default component.exports